import { render, staticRenderFns } from "./kpi.vue?vue&type=template&id=a50e35d2&scoped=true&"
import script from "./kpi.vue?vue&type=script&lang=js&"
export * from "./kpi.vue?vue&type=script&lang=js&"
import style0 from "./kpi.vue?vue&type=style&index=0&id=a50e35d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50e35d2",
  null
  
)

component.options.__file = "kpi.vue"
export default component.exports